import removeExtraSubFieldsHelper from '../helpers/removeExtraSubFieldsHelper';

const reverseTransform = rumor => ({ ...removeExtraSubFieldsHelper(rumor, ['player', 'clubs']) });

export { reverseTransform };
